<template>
  <section class="main-section main-section--white search-section">
    <div class="container">
      <search-bar />
      <content-filter-details />
      <search-result />
      <content-modal />
      <content-copy-modal />
    </div>
  </section>
</template>

<script>
import SearchBar from '@/components/search/SearchBar'
import SearchResult from '@/components/search/SearchResult'
import ContentFilterDetails from '@/components/contents/ContentFilterDetails'
import ContentModal from '@/components/contents/ContentModal'
import ContentCopyModal from '@/components/contents/ContentCopyModal'

export default {
  name: 'SearchPage',

  components: {
    SearchBar,
    SearchResult,
    ContentFilterDetails,
    ContentModal,
    ContentCopyModal
  },

  created () {
    this.$emit('loadingDone')
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/pages/search/SearchPage.vue